<template>
  <div>
  <el-row :gutter="20" class="top-block">
    <Breadcrumb :route="this.$route"></Breadcrumb>
  </el-row>

  <el-row class="ml-20 mr-20" >
    <el-col :xs="12" :sm="12" :lg="12">
      <el-button icon="el-icon-search" circle type="warning" @click="drawer = true"></el-button>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="12">
      
    </el-col>
  </el-row>

  <el-row> 
    

    


    <!-------------------------------------------------------------------->
    <!-- table -->
    <!-------------------------------------------------------------------->
    <el-col :xs="24" :sm="24" :lg="24">
      <el-main>
        <el-card>
          <el-row >
            <el-col :xs="24" :sm="24" :lg="12">
              <p style="font-size: 24px;">哩程補貼申請資料</p>
            </el-col>
            <el-col :xs="24" :sm="24" :lg="12">
              <el-button @click.prevent="exportCurrent" class="fr" type="primary" size="mini">匯出哩程資料 <i class="el-icon-upload2"></i></el-button>
            </el-col>
          </el-row>
          <el-table class="mt-20" :data="tableData" empty-text="目前尚無資料" stripe header-row-class-name="headerStyle">
            <el-table-column prop="username" label="姓名" width="120">
            </el-table-column>
            <el-table-column prop="title" label="關聯日報">
              <template slot-scope="props">
                <p><a target="blank" :href="`#/report/miles-subsidy-forward/${props.row.relatedTodoId}`">{{ props.row.relatedTodo.startDate | fmtDate }} {{ props.row.relatedTodo.title }}</a></p>
              </template>
            </el-table-column>
            <el-table-column prop="startDate" label="日期">
              <template slot-scope="props">
                <p><b>{{ props.row.startDate | fmtDate }}</b></p>
              </template>
            </el-table-column>
            
            <el-table-column prop="startMile" label="哩程">
              <template slot-scope="props">
                {{ props.row.startAddress }}~<BR/>{{ props.row.endAddress }}
              </template>
            </el-table-column>
            <el-table-column prop="myMile" label="當天哩程數">
            </el-table-column>
            <el-table-column prop="carType" label="交通工具">
            </el-table-column>
          </el-table>

          <!-- 匯總表 -->
          <el-table :data="summaryTableData" border style="width: 100%" empty-text="目前尚無資料" stripe header-row-class-name="headerStyle">
            <el-table-column prop="_applyDays" label="總申請天數">
            </el-table-column>
            <el-table-column prop="_motorMiles" label="機車哩程小計">
            </el-table-column>
            <el-table-column prop="_carMiles" label="汽車哩程小計">
            </el-table-column>
          </el-table>
        </el-card>


        <el-card class="mt-20">
          <el-row >
            <el-col :xs="24" :sm="24" :lg="12">
              <p style="font-size: 24px;">哩程補貼統計</p>
            </el-col>
            <el-col :xs="24" :sm="24" :lg="12">
              <el-button @click.prevent="exportCurrentSummary" class="fr" type="primary" size="mini">匯出補貼統計 <i class="el-icon-upload2"></i></el-button>
            </el-col>
            
          </el-row>
          <el-row class="mt-20">
            <el-col :xs="24" :sm="24" :lg="24">
              填入實際上班天數 : <el-input-number v-model="workDays" @change="handleChange" :min="0" :max="31"></el-input-number>
              <el-button type="primary" @click.prevent="execCalculate" class="ml-20">計算</el-button>
            </el-col>
          </el-row>

          <el-table class="mt-20" :data="motorSubsidyTableData" border style="width: 100%" empty-text="目前尚無資料" stripe >
            <el-table-column prop="_workDays" label="實際上班天數">
            </el-table-column>
            <el-table-column prop="_applyDays" label="實際申請天數">
            </el-table-column>
            <el-table-column prop="_motorBase" label="機車津貼">
            </el-table-column>
            <el-table-column prop="_motorMiles" label="機車哩程">
            </el-table-column>
            <el-table-column prop="_motorSubsidy" label="機車哩程補助費">
            </el-table-column>
            <el-table-column prop="_motorFinal" label="補助金額小計">
            </el-table-column>
          </el-table>
          

          <el-table :data="carSubsidyTableData" border style="width: 100%" empty-text="目前尚無資料" stripe>
            <el-table-column prop="_workDays" label="實際上班天數">
            </el-table-column>
            <el-table-column prop="_applyDays" label="實際申請天數">
            </el-table-column>
            <el-table-column prop="_motorBase" label="汽車津貼">
            </el-table-column>
            <el-table-column prop="_carMiles" label="汽車哩程">
            </el-table-column>
            <el-table-column prop="_carSubsidy" label="汽車哩程補助費">
            </el-table-column>
            <el-table-column prop="_carFinal" label="補助金額小計">
            </el-table-column>
          </el-table>
          <el-table :data="calcResultTableData" empty-text=" " :show-header="false">
            <el-table-column>
              <template slot-scope="props">
                <p style="text-align: right">{{props.row._calcResultLabel}}</p>
              </template>
            </el-table-column>
            <el-table-column width="100%">
              <template slot-scope="props">
                <p>${{props.row._calcResultSum}}</p>
              </template>
            </el-table-column>
          </el-table>
        </el-card>

        

      </el-main>

    </el-col>

    <!-------------------------------------------------------------------->
    <!-- dialog -->
    <!-------------------------------------------------------------------->
    
  </el-row>

  <el-drawer
        size="70%"
        title="搜尋哩程統計"
        :visible.sync="drawer"
        :direction="direction"
        :before-close="handleClose">

        <el-main>
            <!-- <el-row class="ml-20 mr-20" >
              <el-col :xs="24" :sm="24" :lg="24">
                <el-select v-model="queryField" placeholder="選擇申請單類型" style="padding: 0 0 0 20px">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
                  
              </el-col>
            </el-row> -->

            <el-row class="mr-20" >
              <el-col :xs="24" :sm="24" :lg="24">
                <span class="demonstration">起</span>
                <br/>
                  <el-date-picker
                    v-model="startDate"
                    type="date"
                    format="yyyy/MM/dd"
                  value-format="yyyy/MM/dd"
                    placeholder="選擇日期" class="mt-10">
                  </el-date-picker>
              </el-col>
            </el-row>

            <el-row class="mr-20 mt-20" >
              <el-col :xs="24" :sm="24" :lg="24">
                <span >迄</span>
                <br/>
                <el-date-picker
                  v-model="endDate"
                  type="date"
                  format="yyyy/MM/dd"
                  value-format="yyyy/MM/dd"
                  placeholder="選擇日期" class="mt-10">
                </el-date-picker>
              </el-col>
            </el-row>
            
            <el-row class="mr-20 mt-20" >
              <el-col :xs="24" :sm="24" :lg="24">
                <span >人員</span>
                <br/>
                <el-autocomplete
                  class="inline-input full-width-input mt-10"
                  v-model="empLabel"
                  :fetch-suggestions="queryEmp"
                  placeholder="輸入工號或姓名"
                  :trigger-on-focus="false"
                  @select="handleSelect"
                  clearable
                  @clear="empId=''"
                ></el-autocomplete>
              </el-col>
            </el-row>

          </el-main>

      <el-button type="primary" @click.prevent="search" class="ml-20">查詢</el-button>
      <el-button type="normal" @click.prevent="clearQuery" class="ml-10">清除條件</el-button>
      

     
    </el-drawer>

 

</div>
</template>

<script>
import {mapState} from 'vuex'
import Breadcrumb from "@/components/breadcrumb/Breadcrumb";
import dayjs from "dayjs";

export default {
  name: "MilesSubsidyStatistic",
  components: {
    Breadcrumb
  },
  data() {

    return {
      drawer:false,
      direction: 'ltr',

      // queryField:'',
      empId:'',
      empLabel:'',
      startDate:'',
      endDate:'',
      tableData:[],

      applyDays:0, //有申請的天數
      motorMiles:0,//機車里程統計
      carMiles:0,//汽車里程統計

      summaryTableData:[],
      motorSubsidyTableData:[], //機車補貼表
      carSubsidyTableData:[], //汽車補貼表
      mileSubsidyForm:{},
      workDays:0, //實際上班日
      calcResultTableData:[], //津貼總計表
      motorFinal:0,
      carFinal:0,

      subsidyTableData:[],
      car_base:0,
      car_per_km:0,
      motor_base:0,
      motor_per_km:0
    }
  },
  computed: {
    ...mapState('login', ['userInfo']),
  },
  methods: {
    handleClose(){
      this.drawer = false
    },

    loadData(){
      //clear summary
      this.motorSubsidyTableData = []
      this.carSubsidyTableData = []
      this.workDays = 0
      
      let {startDate, endDate, empId} = this
      let url = "/report/miles-subsidy?startDate="+startDate+"&endDate="+endDate+"&empId="+empId
      this.request.get(url).then(res => {
          if (res.code === '200') {
            this.tableData = res.data
            this.summary()
          } else {
            this.showResult('success', '資料取得失敗')
          }
        })
    },

    summary() {
      let motor = 0
      let car = 0
      let dateArray = []
      this.tableData.forEach((r) => {
        if (r.carType === '機車') {
          motor += r.myMile
        } else if (r.carType === '汽車') {
          car += r.myMile
        }
        dateArray.push(r.startDate)
      });

      // console.log('dateArray:',dateArray)
      // 將陣列轉換為 Set，以刪除重複的值
      var uniqueArray = [...new Set(dateArray)];


      this.applyDays = uniqueArray.length
      this.motorMiles = motor.toFixed(1)
      this.carMiles = car.toFixed(1)

      this.summaryTableData = [{
        _applyDays: uniqueArray.length,
        _motorMiles: motor.toFixed(1),
        _carMiles: car.toFixed(1),
      }]

    },

    search(){
      this.drawer = false
      let q = {
        startDate: this.startDate,
        endDate: this.endDate,
        empId: this.empId,
        empLabel: this.empLabel
      }
      localStorage.setItem('LH_MILES_SUBSIDY_REPORT_QUERY', JSON.stringify(q))
      this.loadData()
    },
    clearQuery(){
      this.drawer = false
      this.startDate = ''
      this.endDate = ''
      this.empId = ''
      this.empLabel = ''
      this.loadData()
    },
    queryEmp(str, cb){
      
      this.request.get("/user/q?keyword=" + str).then(res => {
        if (res.code === '200') {

          let list = res.data.map((item) => {
            return {
              value: item.username,
              id: item.id 
            }
          })
          cb(list)
        }
      })
    },
    handleSelect(item) {
      this.empId = item.id
    },
    exportCurrent() {
      let {startDate, endDate, empId} = this
      let url = "/report/miles/export-current-subsidy?startDate="+startDate+"&endDate="+endDate+"&empId="+empId
      window.open(process.env.VUE_APP_API_SERVER+url, "new")
    },
    handleChange(){

    },
    execCalculate(){
      this.calculateMotor() 
      this.calculateCar()
      this.showCalculateTotal()
    },

    calculateMotor(){ //計算機車
      let actualWorking = this.workDays //1.實際上班天數
      let applyDays = this.applyDays //2.有申請的天數
      let baseRate = this.motor_base //3.基本津貼
      let motorMiles = this.motorMiles //4.機車哩程數
      let motorSubsidy = Math.round((motorMiles * this.motor_per_km).toFixed(1)) //5.機車哩程補助
      this.motorFinal = Math.round(parseFloat((applyDays / actualWorking) * baseRate) + parseFloat(motorSubsidy))


      // console.log('1.實際上班天數:', actualWorking)
      // console.log('2.有申請的天數:', applyDays)
      // console.log('3.基本津貼:', baseRate)
      // console.log('4.機車哩程數:', motorMiles)
      // console.log('5.補助:', motorSubsidy)
      // console.log('公式:', (applyDays/actualWorking)*baseRate )
      // console.log('小計:', this.motorFinal)

      if (this.motorMiles == 0) {
        this.motorFinal = 0 
      }
      this.motorSubsidyTableData = [{
        _workDays: this.workDays, 
        _applyDays: this.applyDays,
        _motorBase: '$'+baseRate,
        _motorMiles: this.motorMiles,
        _motorSubsidy: '$'+motorSubsidy,
        _motorFinal: '$'+this.motorFinal
      }]
    },

    calculateCar(){ //計算汽車
      let actualWorking = this.workDays //1.實際上班天數
      let applyDays = this.applyDays //2.有申請的天數
      let baseRate = this.car_base //3.基本津貼
      let carMiles = this.carMiles //4.汽車哩程數
      let carSubsidy = Math.round((carMiles * this.car_per_km).toFixed(1)) //5.汽車哩程補助
      this.carFinal = Math.round(parseFloat((applyDays / actualWorking) * baseRate) + parseFloat(carSubsidy))


      // console.log('1.實際上班天數:', actualWorking)
      // console.log('2.有申請的天數:', applyDays)
      // console.log('3.基本津貼:', baseRate)
      // console.log('4.汽車哩程數:', carMiles)
      // console.log('5.補助:', carSubsidy)
      // console.log('公式:', (applyDays/actualWorking)*baseRate )
      // console.log('小計:', this.carFinal)

      if (this.carMiles == 0) {
        this.carFinal = 0 
      }
      this.carSubsidyTableData = [{
        _workDays: this.workDays, 
        _applyDays: this.applyDays,
        _motorBase: '$'+baseRate,
        _carMiles: this.carMiles,
        _carSubsidy: '$'+carSubsidy,
        _carFinal: '$'+this.carFinal
      }]
    },

    showCalculateTotal(){ //機車+汽車
      this.calcResultTableData =[{
        _calcResultLabel:'交通津貼總計',
        _calcResultSum: parseInt(this.motorFinal) + parseInt(this.carFinal)
      }]
    },

    exportCurrentSummary() {
      let {startDate, endDate, empId, workDays} = this
      let url = "/report/miles/export-sum?startDate="+startDate+"&endDate="+endDate+"&empId="+empId+"&workDays="+workDays
      window.open(process.env.VUE_APP_API_SERVER+url, "new")
    },
    loadDefinition(){
      let req = '/dic/type?queryField=subsidy'
      this.request.get(req).then(res => {
        if (res.code === '200') {
          this.subsidyTableData = res.data
          this.subsidyTableData.forEach((element) => {
            if (element.name === 'car_base') {
              this.car_base = parseInt(element.value)
            } else if (element.name === 'car_per_km') {
              this.car_per_km = parseFloat(element.value)
            } else if (element.name === 'motor_base') {
              this.motor_base = parseFloat(element.value)
            } else if (element.name === 'motor_per_km') {
              this.motor_per_km = parseFloat(element.value)
            }
          });
        }
      })
    }

  },
  mounted() {
    let cache = localStorage.getItem('LH_MILES_SUBSIDY_REPORT_QUERY')
    let cacheObj = JSON.parse(cache)
    if (cache !== null) {
      this.startDate = cacheObj.startDate
      this.endDate = cacheObj.endDate
      this.empId = (typeof cacheObj.empId === 'undefined')? '': cacheObj.empId
      this.empLabel = (typeof cacheObj.empLabel === 'undefined')? '': cacheObj.empLabel
    } else {
      this.startDate = ''
    }

    this.loadData()
    this.loadDefinition()
  }
}
</script>

<style scoped>
.el-table {
  border-radius: 10px;
  padding: 20px;
}

.avatar-uploader {
  /*border: 1px dashed #d9d9d9;*/
  /*border-radius: 6px;*/
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;
  text-align: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.start_import {
  display: block;
}

.stop_import {
  display: none;
}

.el-table >>> .headerStyle {
  background-color: #1e8fc6;
}

</style>
